import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AccountResolverServiceProvider } from "@webapp/accounts/providers/account-resolver.provider";
import { AccountServiceProvider } from "@webapp/accounts/providers/account.provider";
import { LanguagesConfigServiceProvider } from "@webapp/localization/providers/language-config.provider";
import { Ng1StateProxyProvider } from "@webapp/core/provider-upgrade/providers/ng1-state.proxy";
import { SharedModule } from "@webapp/shared/shared.module";
import { UiModule } from "@webapp/ui/ui.module";
import { LanguageComponent } from "./components/language/language.component";
import { ReportsAndNotificationsComponent } from "./components/reports-and-notifications/reports-and-notifications.component";

@NgModule({
  imports: [UiModule, FormsModule, CommonModule, SharedModule],
  declarations: [LanguageComponent, ReportsAndNotificationsComponent],
  providers: [AccountResolverServiceProvider, AccountServiceProvider, Ng1StateProxyProvider, LanguagesConfigServiceProvider],
})
export class ConfigurationModule {}
